<template>
  <div
    :class="[
      $style.container,
      'flex',
      reverse && $style.reverse,
      theme && $style[theme]
    ]">
    <bvc-button
      :theme="confirmButtonTheme"
      :disabled="disabledConfirm"
      :size="size"
      :class="[$style.button, $style.confirmButton]"
      @click="handleConfirm"
      data-testid="confirm-btn"
      :tag="confirmHref ? 'a' : 'button'"
      :href="confirmHref"
      :target="confirmTarget"
    >
      <slot name="confirm">{{ $t('confirm') }}</slot>
    </bvc-button>

    <bvc-button
      :size="size"
      :theme="cancelButtonTheme"
      :class="[$style.button, $style.cancelButton]"
      :disabled="disabledCancel"
      @click="handleCancel"
      data-testid="cancel-btn"
    >
      <slot name="cancel">{{ $t('cancel') }}</slot>
    </bvc-button>
  </div>
</template>

<script>
import BvcButton from '@/booksy-vue-components/components/b-button/index.vue'
import { SIZES } from '@/booksy-vue-components/mixins/input-size.js'

export default {

  emits: [
    'cancel',
    'confirm',
  ],
  components: {
    BvcButton,
  },

  props: {

    danger: {
      type: Boolean,
      default: false,
    },

    reverse: {
      type: Boolean,
      default: false,
    },

    theme: {
      type: String,
      required: false,
    },

    size: {
      type: String,
      default: 'lg',
      validator: (value) => SIZES.includes(value),
    },

    disabledConfirm: {
      type: Boolean,
      default: false,
    },

    disabledCancel: {
      type: Boolean,
      default: false,
    },

    confirmHref: {
      type: String,
      required: false,
    },

    confirmTarget: {
      type: String,
      required: false,
    },
  },

  computed: {
    confirmButtonTheme () {
      if (this.danger) {
        return 'alert'
      }

      if (this.reverse) {
        return 'primary'
      }

      return 'default'
    },

    cancelButtonTheme () {
      return this.reverse ? 'default' : 'primary'
    },
  },

  methods: {

    handleConfirm (e) {
      this.$emit('confirm', e)
    },

    handleCancel (e) {
      this.$emit('cancel', e)
    },

  },
}
// MODALS.

</script>

<style lang="scss" module>
@layer legacy-views {

.confirmButton {
  margin-right: 16px;
}

.reverse {
  flex-direction: row-reverse;

  .cancelButton {
    margin-right: 16px;
  }

  .confirmButton {
    margin-right: 0;
  }
}

.column {
  flex-direction: column;

  .button {
    margin-top: 14px;
    margin-right: 0;
  }
}

.column-reverse {
  flex-direction: column-reverse;

  .button {
    margin-top: 14px;
    margin-right: 0;
  }
}

}</style>
